<template>
  <vx-card class="mt-base" title="Law Activity 9 - Civil Case Scenario - Part #3">
    <h4 class="mb-5">Determining Damages</h4>

    <p class="mb-5">
      This video focuses on the role of a jury in a civil matter and on the process of determining
      damages.
    </p>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      label="Play video: Civil Trial, Episode 3"
      @clicked="showIframePopup(videos[1].video)"
    />

    <h4 class="mb-5">Your Task: Have Your Say!</h4>

    <p class="mb-5">
      Imagine you are a member of the jury. Think about the factors that need to be considered in
      determining the types and amount of damages paid. Decide the types of damages your jury agrees
      to and the amount based on what you’ve seen and heard in the videos on this case. You may like
      to do a little research regarding the plaintiff’s potentially lost earnings and on other
      awarded damages in similar cases. Record the figure you decide below.
    </p>
    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>$</strong></p>
      <text-block
        v-model="data.question1"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>
    <p class="mb-5">
      <strong>Write a few sentences to justify the amount you decided upon.</strong>
    </p>
    <textarea-block v-model="data.question2" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import methods from '@/views/WorkExperiences/components/activity_js/methods';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/civil_case_part_3_splash.jpg'),
          video: 'https://www.youtube.com/embed/KABZIodPacI',
        },
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
